export default "__VITE_ASSET__DnEep46Z__"